module.exports = __webpack_public_path__ + "img/team3.48c64701.png";